module.exports = __webpack_public_path__ + "img/curso-online.5ba445d2.png";